var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m16 2.6667c7.352 0 13.333 5.9813 13.333 13.333s-5.9813 13.333-13.333 13.333-13.333-5.9813-13.333-13.333 5.9813-13.333 13.333-13.333zm0-2.6667c-8.836 0-16 7.164-16 16s7.164 16 16 16 16-7.164 16-16-7.164-16-16-16zm-2.6667 13.333h-2.6666v2.6667h2.6666v8h4v-8h2.4267l0.24-2.6667h-2.6667v-1.1106c0-0.6374 0.128-0.8894 0.744-0.8894h1.9227v-3.3333h-3.2053c-2.3974 0-3.4614 1.056-3.4614 3.0773v2.256z","fill":"#4693FF"}));
}

Facebook.defaultProps = {"fill":"none","viewBox":"0 0 32 32"};

module.exports = Facebook;

Facebook.default = Facebook;
